type Pattern = {
    color: string
    code: string
    description: string
    img: HTMLImageElement
}

export default class LithologyPatterns {
    private patterns = new Map<number, Pattern>()
    private canvasPatterns

    constructor() {
        this.patterns = new Map<number, Pattern>()
        this.canvasPatterns = {}
    }

    isEmpty(): boolean {
        return this.patterns.size === 0
    }

    buildCanvasPattern(ctx: CanvasRenderingContext2D) {
        for (const [code, value] of this.patterns.entries()) {
            if (!this.canvasPatterns[code] && value.img) {
                this.canvasPatterns[code] = ctx.createPattern(value.img, 'repeat')
            }
        }
    }

    getCanvasPattern(code: number, ctx: CanvasFillStrokeStyles) {
        if (this.canvasPatterns[code]) {
            return this.canvasPatterns[code]
        } else if (this.patterns.has(code)) {
            const pattern = this.patterns.get(code)
            if (pattern && pattern.img) {
                this.canvasPatterns[code] = ctx.createPattern(pattern.img, 'repeat')

                return this.canvasPatterns[code]
            }
        }

        return null
    }

    load(items: any[], onUpdate) {
        const set = items.reduce((set: Map<number, any>, item) => {
            item.lithologys.forEach(lith => {
                if (!set.has(lith.code)) {
                    set.set(lith.code, {
                        code: lith.code,
                        description: lith.description,
                        color: lith.color
                    })
                }
            })

            return set
        }, new Map<number, any>())

        // loading patterns
        const promisses = [...set.values()]
            .filter(item => item.code && !this.patterns.has(item.code))
            .map(
                item =>
                    new Promise((resolve, reject) => {
                        const img = new Image()
                        img.src = `/content/plugin-drilling-widgets/${item.code}.png`
                        img.onload = function (ev) {
                            resolve([item, this])
                        }
                        img.onerror = function (e) {
                            resolve([null, null])
                        }
                    })
            )

        if (promisses.length > 0) {
            // save on pattern structure and redraw
            Promise.all(promisses).then(values => {
                values.forEach(([item, img]) => {
                    if (item) {
                        this.patterns.set(item.code, {
                            ...item,
                            img
                        })
                    }
                })
                onUpdate()
            })
        }
    }

    values() {
        return this.patterns.values()
    }

    has(code: number) {
        return this.patterns.has(code)
    }

    get(code: number) {
        return this.patterns.get(code)
    }
}
